/* eslint-disable prefer-promise-reject-errors */

import axios from 'axios';
import { checkCacheReset, checkForCacheIssue } from './axiosCacheReset';

const axiosCacheCheck = axios.create({ });

axiosCacheCheck.interceptors.request.use((config) => {
  checkCacheReset(config);
  return config;
});

axiosCacheCheck.interceptors.response.use(
  (response) => {
    checkForCacheIssue(response);
    return response;
  },
  (error) => {  
    if (error.response?.status === 401) {
      window.location.href = `/auth/login?returnUrl=${window.location.href}`;
      return Promise.reject('401 Unauthorized');
    }
    if (error.response?.status === 403) {
      console.error('403 Forbidden', window.location.href);
      return Promise.reject('403 Forbidden');
    }
    return Promise.reject((error.response && error.response.data) || 'Something went wrong');
  }
);

export default axiosCacheCheck;
